import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../shared/user.service';
import { Search } from '../../../shared/user.model';
import swal from 'sweetalert2';

@Component({
  selector: 'app-project-grid',
  templateUrl: './project-grid.component.html',
  styleUrls: ['./project-grid.component.css']
})
export class ProjectGridComponent implements OnInit {
  title = "View Project";
  itemsPerPage: number = 5;
  currentPage: number = 1;
  totalItems: number;
  projectList:any=[];
  ul:any={};
  s: Search;
  isSearch:boolean = false;
  data: any;

//   transform(SearchText: any) {
//     if (!SearchText) {
//         return '';
//     }

//     return SearchText.trim();
// }
  constructor(private userService: UserService,private route: ActivatedRoute,private router: Router, private errorHandler:ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }

  ngOnInit() {
    this.GetAllProjects(this.itemsPerPage, 1)
  }

  pageChanged(pageNumber: number) {
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
    else
      this.GetAllProjects(this.itemsPerPage, pageNumber);
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNo);
    else
      this.GetAllProjects(this.itemsPerPage, pageNo);
  }

  GetAllProjects(itemsPerPage: number, pageNo: number) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllProjects(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.projectList = data.projectmodel;
          console.log(this.projectList);
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          //this.errorHandler.HandlerError(error);
        });
  }


  DeleteProject(Tr_Pro_Id){
    debugger;
    swal({
         title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
        this.data = this.userService.DeleteProject(Tr_Pro_Id);
        this.data.subscribe(
         (response: any) => {
             this.GetAllProjects(this.itemsPerPage, 1)          
         },       
      ); 
    } 
    })
    }


    onSearch(s, itemsPerPage: number, pageNo: number) {  
      debugger; 
      this.isSearch = true;
      let searchText = this.s.SearchText;
      let searchCriteria = this.s.SearchCriteria;
      if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
        swal("Warning!", "Please enter the search criteria and search text.", "warning");
      else {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.SearchProject(searchCriteria, searchText,itemsPerPage,pageNo)
          .subscribe(
            (data: any) => {
              if(data.projectmodel.length!=0){              
            this.projectList = data.projectmodel;
            this.totalItems = data.TotalItemsCount;
            this.itemsPerPage = itemsPerPage;
            this.currentPage = pageNo;
              document.getElementById('loader-spinner').style.display = "none";
            }
            else
            {
            document.getElementById('loader-spinner').style.display = "none";         
            }
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              //swal('Search Failed.');
              //this.errorHandler.HandlerError(error);
            });
      }
    }
  

}



// WEBPACK FOOTER //
// ./src/app/masters/project/project-grid/project-grid.component.ts